import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

export function fetchSiteContent() {
  if (!inflight) {
    inflight = api.get("/content")
      .then((r) => { cache = r.data || {}; return cache; })
      .catch(() => cache || {})
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export function useSiteContent() {
  const [content, setContent] = useState(cache);
  useEffect(() => {
    let on = true;
    fetchSiteContent().then((d) => { if (on) setContent(d); });
    return () => { on = false; };
  }, []);
  return content;
}

export const mediaSrc = (v) => (v ? (v.startsWith("http") ? v : `${process.env.REACT_APP_BACKEND_URL}${v}`) : "");
